import React from 'react';
import { Box, Typography } from '@material-ui/core';

interface AffiliateLayoutProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
}

const AffiliateLayoutSimple: React.FC<AffiliateLayoutProps> = ({ 
  children, 
  title = 'Affiliate Dashboard',
  subtitle = 'Manage your affiliate account and track performance'
}) => {
  return (
    <Box style={{ 
      minHeight: '100vh', 
      backgroundColor: '#02172a', 
      color: '#fff',
      padding: '2rem'
    }}>
      <Typography variant="h4" style={{ color: '#fff', marginBottom: 16 }}>
        {title}
      </Typography>
      <Typography variant="body1" style={{ color: '#ccc', marginBottom: 24 }}>
        {subtitle}
      </Typography>
      {children}
    </Box>
  );
};

export default AffiliateLayoutSimple;
